// Importing Style 
import '../../styles/home_styles/hero.scss';

function Hero () {
    return(
        <section id="home-hero">
            <div id="overlay"></div>
            <div id="text">
                <h1>Let's Learn</h1>
                <h5>Let's design and develop a better world.</h5>    
            </div>
        </section>
    )
}

export default Hero;